module.exports = __webpack_public_path__ + "img/integraciondeequipos.1b0ca71d.svg";